export const getStyled = (theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: 'auto',
    ...theme.custom.scrollbarStyles,
    backgroundColor: theme.custom.colors.defaultBackground,

    borderColor: theme.palette.mode === 'light' ? '#192734' : '#8C939A',
    color: ` ${theme.custom.colors.text} !important`,

    '& .MuiTableCell-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiTypography-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiIconButton-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiAvatar-root': {
      color: `${theme.custom.colors.text} !important`,
    },
  },

  customTableCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: theme.typography.pxToRem(14),
    border: '1px solid #dadde9',
    maxWidth: 450,
  },

  tooltipPopper: {
    textAlign: 'center',
  },

  buttonProgress: {
    color: theme.custom.colors.editButton,
  },

  TableHead: {
    backgroundColor: theme.custom.colors.barraSuperior,
    borderRadius: '5px',

    '& .MuiTableCell-root': {
      color: '#fff !important',
    },
  },
});
